'use client'
import { getStore } from '../../store.js';
import { useStoreWithSelector } from '../useStoreWithSelector/useStoreWithSelector.js';

const useUser = () => {
    var _a, _b;
    const userFromStore = useStoreWithSelector(getStore(), ({ user }) => user);
    // adding unauthenticatedUser to avoid breaking changes for customer who consider that when we have a user,
    // it means that they are already fully authenticated.
    // since we won't have onboarding jwt anymore, the idea is to just store the user in LS and either use the user state
    // or unauthenticatedUser, depending on the value of missing fields or mfa required.
    // this is just following our existing logic of how we handle authToken vs onboardingOnlyToken.
    if (((_a = userFromStore === null || userFromStore === void 0 ? void 0 : userFromStore.missingFields) === null || _a === void 0 ? void 0 : _a.length) ||
        ((_b = userFromStore === null || userFromStore === void 0 ? void 0 : userFromStore.scope) === null || _b === void 0 ? void 0 : _b.includes('requiresAdditionalAuth'))) {
        return { unauthenticatedUser: userFromStore };
    }
    return { user: userFromStore };
};

export { useUser };
